import { DataTable } from "primereact/datatable";
import React, { useState, useRef, useContext } from "react";
import { useMutateBulkGtfsResource, useMutateGtfsResource, useQueryGtfsResource, useQueryGtfsResourceById } from "../../Queries";
import { ProgressSpinner } from "primereact/progressspinner";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ContextMenu } from "primereact/contextmenu";
import { PlatformIndicator } from "../../components/PlatformIndicator";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { formatDateToTimeString, isValidGtfsTimeFormat, parseTimeStringToDate, formatGtfsTimeString } from "../../helpers/gtfsDateUtils";
import { InputMask } from "primereact/inputmask";
import { Checkbox } from "primereact/checkbox";
import { ariaLabel } from "primereact/api";
import { Message } from "primereact/message";
import { OverlayContext } from "../../OverlaysContext";
import { StopIdPropertyDropdown } from "../../components/StopIdPropertyDropdown";
import { mainToolset, ToolsContext, ToolsDispatchContext } from "../../ToolsContext";


export function TimetableEditor({routeId}) {
    const [visibleDialog, setVisibleDialog] = useState(null);
    const [selectedCells, setSelectedCells] = useState(null);
    const [directionId, setDirectionId] = useState(0);
    const {data, isPending, error} = useQueryGtfsResourceById('timetables',routeId);
    const bulkMutation = useMutateBulkGtfsResource();
    const singleMutation = useMutateGtfsResource();
    const handleOverlay = useContext(OverlayContext);
    const cmst = useRef(null);
    const cms = useRef(null);

    /* Pobieranie danych */
    if (error) return <>{error.message}</>;
    if (isPending || !data) return <ProgressSpinner />;

    const content = Object.values(data.timetable[directionId]);
    const trips = Object.values(data.trips[directionId]);

    /* Menu kontekstowe postoju */
    const stopTimeMenuItems = [
        {
            label: 'Dodaj postój',
            icon: 'fa-solid fa-square-plus',
            command: () => {
                let previousKid = getPreviousStopTimeKid(content,selectedCells[0].field.replace('trip_deps.',''),selectedCells[0].rowIndex);
                console.log('prev kid',previousKid);
                setVisibleDialog('stopTime')
            },
            visible: (Array.isArray(selectedCells) && selectedCells.length === 1 && getSelectedCellStopTimeKids(selectedCells)[0] == undefined)
        },
        {
            label: 'Edycja postoju',
            icon: 'fa-solid fa-edit',
            command: () => {setVisibleDialog('stopTime')},
            visible: (Array.isArray(selectedCells) && selectedCells.length === 1 && getSelectedCellStopTimeKids(selectedCells)[0] != undefined)
        },
        { 
            label: 'Przesuwanie w czasie', 
            icon: 'fa-solid fa-clock-rotate-left', 
            items: [
                {
                    label: 'Minutę wcześniej',
                    command: () => handleBulkShift(-60)
                },
                {
                    label: 'Minutę później',
                    command: () => handleBulkShift(60)
                },
                {
                    separator: true
                },
                {
                    label: 'Godzinę wcześniej',
                    command: () => handleBulkShift(-60*60)
                },
                {
                    label: 'Godzinę później',
                    command: () => handleBulkShift(60*60)
                },
                {
                    separator: true
                },
                {
                    label: 'Określ czas',
                    command: () => {setVisibleDialog('bulkShift')}
                }
            ]
        },
        { 
            label: 'Kopiowanie', 
            icon: 'fa-solid fa-copy', 
            items: [
                {
                    label: 'Kopiuj przyjazdy',
                    icon: 'fa-solid fa-right-to-bracket',
                    command: () => copyTimetable(selectedCells,true)
                },
                {
                    label: 'Kopiuj odjazdy',
                    icon: 'fa-solid fa-right-from-bracket',
                    command: () => copyTimetable(selectedCells)
                }
            ]
        },
        {
            label: 'Przenoszenie',
            icon: 'fa-solid fa-location-dot',
            items: [
                {
                    label: 'Na inny przystanek',
                    command: () => {setVisibleDialog('bulkMoveToStop')}
                }
            ]
        },
        {
            label: (Array.isArray(selectedCells) && selectedCells.length === 1) ? 'Usuń postój' : 'Usuń postoje',
            icon: 'fa-solid fa-trash',
            command: () => handleBulkDelete(),
            visible: (Array.isArray(selectedCells) &&  getSelectedCellStopTimeKids(selectedCells)[0] != undefined)
        }
    ]

    /* Menu kontekstowe przystanku */
    const stopMenuItems = [
        {
            label: "Dodaj przystanek",
            icon: 'fa-solid fa-plus',
            items: [
                {
                    label: 'W tym miejscu'
                },
                {
                    label: 'Po tym przystanku'
                }
            ]
        }
    ]

    /* Naprawiamy po tych chujkach, co nie zaimplementowały zaznaczania pojedynczych komórek
    poprzez contextMenu */
    const handleCellContextMenu = (e, selection) => {
        if (cmst.current) {
            cmst.current.show(e);
        }
    }


    /* Różne akcje */

    const handleBulkDelete = () => {
        const kids = getSelectedCellStopTimeKids(selectedCells);

        if (kids.length > 1) {
            /** Komunikat jako zabezpieczenie przed wywaleniem zbyt wielu postojów na raz */
            handleOverlay('confirmDialog',{
                message: 'Zamieszasz usunąć ' + kids.length + ' postojów. Czy chcesz kontynuować?',
                header: 'Masowe usuwanie postojów',
                icon: 'pi pi-info-circle',
                style: { width: '500px '},
                breakpoints: { '960px': '100vw' },
                defaultFocus: 'reject',
                acceptLabel: 'Usuń',
                acceptClassName: 'p-button-danger',
                acceptIcon: 'fa-solid fa-trash',
                rejectLabel: 'Anuluj',
                accept: () => {
                    bulkMutation.mutate({
                        query: {
                            resourceTable: 'timetables',
                            action: 'delete',
                        },
                        fields: {
                            kids: kids
                        }
                    })
                }
            })
        } else {
            /** Pojedyncze usuwanie bez pytania */
            bulkMutation.mutate({
                query: {
                    resourceTable: 'timetables',
                    action: 'delete',
                },
                fields: {
                    kids: kids
                }
            })
        }
    }

    const handleBulkMoveTo = (stopId) => {
        bulkMutation.mutate({
            query: {
                resourceTable: 'timetables',
                action: 'move',
            },
            fields: {
                move_to: stopId,
                kids: getSelectedCellStopTimeKids(selectedCells)
            }
        })     
    }

    const handleBulkShift = (seconds) => {
        bulkMutation.mutate({
            query: {
                resourceTable: 'timetables',
                action: 'shift',
            },
            fields: {
                time: seconds,
                kids: getSelectedCellStopTimeKids(selectedCells)
            }
        })
    }

    const handleBulkUpdate = (newTimes) => {       
        bulkMutation.mutate({
            query: {
                resourceTable: 'timetables',
                action: 'update',
            },
            fields: newTimes
        })        
    }

    const handleSingleUpdate = async (newData) => {
        const payload = {
            query: {
                resourceTable: 'timetables',
                modified_id: newData.kid
            },
            fields: newData.fields
        }
        
        try {
            const asyncMutation = await singleMutation.mutateAsync(payload);
            setVisibleDialog(null);
        } catch(error) {
            let errorCode = error.message.substring(0,3);
            handleOverlay('toast', {
                severity: "error",
                summary: 'Błąd ' + errorCode,
                detail: error.message
            })
        }
    }



    /* Właściwy rendering tabeli */
    // Górna część ze strzałkami do wyboru kierunku
    const headerDirectionTemplate = () => {
        return (
        <div className="flex align-items-center">
            <Button text 
                icon="fa-solid fa-repeat" 
                className="mr-2" 
                style={{height: '.5rem'}} 
                onClick={() => {
                    setDirectionId((directionId === 1) ? 0 : 1);
                }}
            />
           {
                (directionId) ? 'Kierunek POWRÓT' : 'Kierunek TAM'
           }
        </div>
        )
    }

    // Funkcyjka do testowania, czy dana komórka może być zaznaczona. 
    // Przydatne, jeżeli będę chciał zrobić opcję zaznaczania przystanków...
    const isCellSelectable = (event) => (event.data.field === 'stop_name' ? false : true);

    // Pobieranie ciała komórki z przyjazdami/odjazdami z odpowiedniego komponentu
    const stopTimeBodyTemplate = (stopEntry,tripId,cellIndex, handleCellContextMenu) => <StopTimeCell stopEntry={stopEntry} tripId={tripId} cellIndex={cellIndex} handleCellContextMenu={handleCellContextMenu} />
    
    // To pewnie będzie nasz edytor
    const timeEditor = (options) => {
        return <InputMask 
            id="stopTimeArrivalDeparture" 
            mask="99:99:99" 
            placeholder="hh:mm:ss"
            slotChar="hh:mm:ss"
            value={options.value}
            onChange={(e) => options.editorCallback(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            className="w-full text-center"
            style={{
                minWidth: '7rem',
            }}
        />
    }

    const onCellEditComplete = (e) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        if(field.startsWith('trip_deps.')) {
            if(isValidGtfsTimeFormat(newValue)) {
                // prawie optymistyczna aktualizacja przyjazdu
                // odjazdami nie musimy się przejmować, tabela robi to automatycznie
                let tripId = field.replace('trip_deps.','');
                rowData.trip_arvs[tripId] = newValue; 

                // przygotowujemy dane do wysyłki do serwera
                let kid = getSelectedCellStopTimeKids(selectedCells);
                const updateFields = {};
                updateFields[kid] = [newValue, newValue];
                // i wysyłamy
                handleBulkUpdate(updateFields);
            } else {
                event.preventDefault;
            } 
        }

        switch (field) {
            case 'quantity':
            case 'price':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        }
    };

    return <div>
        <DialogBulkShift 
            visible={(visibleDialog === 'bulkShift')}
            onHide={() => setVisibleDialog(null)}
            onOk={(value) => {
                handleBulkShift(value*60) //handleBulkShift przyjmuje sekundy, a okno dialogowe jest w minutach
                setVisibleDialog(null)
            }}
        />
        {
            (getSelectedCellStopTimeData(selectedCells)) ?
            <DialogStopTime 
                key={'dst'+ 
                    (getSelectedCellStopTimeKids(selectedCells)[0]) ? (getSelectedCellStopTimeKids(selectedCells)[0]) : 'new'
                }
                visible={(visibleDialog === 'stopTime')}
                onHide={() => setVisibleDialog(null)}
                initialVal={
                    (Array.isArray(selectedCells)) ?  
                    getSelectedCellStopTimeData(selectedCells)[0] : false
                }
                onOk={(newValue,shiftTime) => {
                    // przygotowujemy dane do wysyłki do serwera
                    const kid = getSelectedCellStopTimeKids(selectedCells)[0];
                    let fields = {}

                    
                    if (typeof kid === 'undefined') {
                        // dodawanie nowego postoju do sekwencji
                        let tripId = selectedCells[0].field.replace('trip_deps.','');
                        let previousKid = getPreviousStopTimeKid(content,tripId,selectedCells[0].rowIndex);
                        fields = {
                            action_type: 'insertStopTime',
                            previous_kid: previousKid,
                            arrival_time: newValue.arrivalTime,
                            departure_time: newValue.departureTime,
                            stop_id: selectedCells[0].rowData.stop_id,
                            shift_time: shiftTime,
                            trip_id: (previousKid) ? null : tripId //tripId potrzebny tylko wtedy, kiedy nie znamy kId poprzedniego postoju
                        }
                    } else {
                        // edycja istniejącego postoju
                        fields = {
                            action_type: 'updateStopTime',
                            arrival_time: newValue.arrivalTime,
                            departure_time: newValue.departureTime,
                            shift_time: shiftTime
                        }
                    }

                    console.log('ok selected cells',selectedCells);
                    // i wysyłamy
                    handleSingleUpdate({
                        kid: kid,
                        fields: fields
                    })
                }}    
            /> : <></>
        }
        <DialogMoveToStop 
                    visible={(visibleDialog === 'bulkMoveToStop')}
                    onHide={() => setVisibleDialog(null)}
                    onOk={(value) => {
                        handleBulkMoveTo(value) //handleBulkShift przyjmuje sekundy, a okno dialogowe jest w minutach
                        setVisibleDialog(null)
                    }}
                    initialVal={(selectedCells && Array.isArray(selectedCells) && selectedCells.length > 0) ? selectedCells[0].rowData.stop_id : ''}
        />

        <ContextMenu ref={cmst} model={stopTimeMenuItems}/>
        <DataTable
            cellSelection
            metaKeySelection
            dragSelection
            selectionMode="multiple"
            selection={selectedCells}
            onSelectionChange={(e) => {
                setSelectedCells(e.value)
                console.log('setSelectedCells e.value',e.value)
            }}
            onContextMenu={(e) => {
                /* Naprawiamy po tych chujkach, co nie zaimplementowały zaznaczania pojedynczych komórek
                poprzez contextMenu */

                let elCellInterior;

                // Numer zaznaczonej komórki w wierszu (tj. kolumny) pobieramy z elementu data-cellIndex, który sami utworzyliśmy w ciele komórki...
                if (e.originalEvent.target.hasAttribute("data-cellIndex")) {
                    elCellInterior = e.originalEvent.target;
                } else {
                    // Jeżeli obiekt, który kliknęliśmy, nie zawiera sam w sobie atrybutu [data-value], to szukamy rodzica, który zawiera
                    elCellInterior = e.originalEvent.target.closest('[data-cellIndex]');
                }
              
                if (!elCellInterior) return; // Nie ma takiego obiektu? Albercik, wychodzimy...
                                
                const cellIndex = parseInt(elCellInterior.getAttribute("data-cellIndex"));
                // Numer zaznaczonego wiersza na szczęście mamy w pierwotnym evencie...
                const rowIndex = e.index;
                
                // Sorawdzanie, czy kliknięta w tej akcji komórka jest częścią zaznaczenia...
                const inSelection = (Array.isArray(selectedCells)) ? selectedCells.some(obj => obj.cellIndex === cellIndex && obj.rowIndex === rowIndex) : false;
                if(!inSelection) {
                    // Jeżeli komórka, którą kliknęliśmy PPM nie jest obecna w zaznaczeniu, odznaczamy wszystko by uniknąć nieporozumień
                    // Pierwotnie robiłem po prostu setSelectedCells(null), ale postanowiłeś się porwać na programatyczne zazn. właściwej komórki

                    // W tym celu muszę sztucznie utworzyć obiekt komórki...
                    setSelectedCells([{
                        cellIndex: cellIndex, 
                        rowIndex: rowIndex,
                        rowData: e.data,
                        // Muszę sfabrykować pole "field" komórki, żeby odpowiadało formatowi... w tym celu pobieram numer tripa z tablicy bazując na indeksie komórki
                        field: 'trip_deps.' + String(trips[cellIndex-1].trip_id)    
                    }]); 
                }
                // Właściwe wywoływanie menu konktekstowego dla zazn. komórek
                handleCellContextMenu(e.originalEvent);
            }}
            scrollable
            scrollHeight="87vh"
            tableStyle={{ 
                minWidth: '50rem', 
                userSelect: 'none',
                fontSize: '.9rem'
            }}
            size="small"
            stripedRows
            editMode="cell"

            value={content}
            isDataSelectable={isCellSelectable}
        >
            <Column frozen
                header={headerDirectionTemplate}
                style={{ width: '400px', minWidth: '400px', maxWidth: '400px' }}
                field='stop_name'
                body={ 
                    (stopEntry) => {
                        return (
                            <div className="flex align-items-center" 
                                style={{ width: '400px', minWidth: '400px', maxWidth: '400px' }}
                            >
                                {stopEntry.stop_name} 
                                <div className="mx-2"><PlatformIndicator platformCode={stopEntry.platform_code} /></div>
                                <div className='text-xs text-200'>{stopEntry.stop_id}</div>
                            </div>
                        )
                    }
                }
            ></Column>
            {trips.map((trip, i) => (
                <Column key={trip.trip_id} 
                    field={"trip_deps." + trip.trip_id}
                    alignHeader="center"
                    header={() => { return <TripHead GTrip={trip} key={'h' + trip.trip_id}></TripHead>} }
                    headerClassName="p-0"
                    headerStyle={{ borderLeft: '1px solid rgba(255, 255, 255, 0.06)', 
                        backgroundColor: 'rgba(255, 255, 255, 0.2)'
                    }}
                    body={(stopEntry) => stopTimeBodyTemplate(stopEntry,trip.trip_id,i+1)}
                    bodyStyle={{
                        /* backgroundColor: (i % 2) ? 'rgba(255, 255, 255, 0.05)' : 'transparent'  -- wyklucza się z zaznaczaniem komórek :( */
                        borderLeft: '1px solid rgba(255, 255, 255, 0.06)',
                        padding: '0',
                        maxWidth: '7rem'
                    }} 
                   editor={(options) => timeEditor(options)}
                   onCellEditComplete={onCellEditComplete}
                   onContextMenu={(e) => console.log('ocm column',e)}
                >    
                </Column>
            ))}
        </DataTable>
    
    </div>
}

/* Komponent z nagłówkiem kursu */
function TripHead({GTrip}) {
    const tool = useContext(ToolsContext);
    const toolDispatch = useContext(ToolsDispatchContext);
    const cmt = useRef(null);

    const menuItems = [
        {
            label: "Edytuj kurs",
            icon: "fa-solid fa-edit",
            command: () => {                
                toolDispatch({
                    type: 'changed',
                    newTool: {
                        ...mainToolset.tools['tripsTool'],
                        selection: GTrip, // zaznacz trasę
                        propertyEditor: {
                            edit: GTrip
                        }
                    }
                })
            }
        }
    ]


    return ( 
        <div className="p-2 m-0 w-full" 
            onContextMenu={(e) => cmt.current.show(e)}
            onDoubleClick={() => {
                toolDispatch({
                    type: 'changed',
                    newTool: {
                        ...mainToolset.tools['tripsTool'],
                        selection: GTrip, // zaznacz trasę
                        propertyEditor: {
                            edit: GTrip
                        }
                    }
                })
            }}>
                <ContextMenu ref={cmt} model={menuItems} />
                <b>{GTrip.trip_id}</b><br />
                <span className="text-xs">{GTrip.service_id}</span>    
        </div>
    )
}

/* Komponent z ciałem komórki z postojem (odjazd, przyjazd) */
function StopTimeCell({stopEntry,tripId,cellIndex}) {
    let cellContent = <></>
    if (!stopEntry.trip_deps[tripId]) {
         cellContent = <>|</>
    } else {
        if (stopEntry.trip_deps[tripId] === stopEntry.trip_arvs[tripId]) {
            cellContent = formatGtfsTimeString(stopEntry.trip_deps[tripId]);
        } else {
            cellContent = (
                <div style={{whiteSpace: 'nowrap'}}>
                    <div style={{ borderBottom: '1px solid gray'}}>
                        <span class="text-xs text-200">p.</span> {formatGtfsTimeString(stopEntry.trip_arvs[tripId])}
                    </div>
                    <div>
                        <span class="text-xs text-200">o.</span> {formatGtfsTimeString(stopEntry.trip_deps[tripId])}
                    </div>
                </div>
            );
        }
    }

    /**  Przekazany przez cellIndex indeks komórki w wierszu (czyli de fakto numer kolumny) potrzebny nam jest do wywoływania menu kontekstowego przez komponent tabeli.
    * To część hacka wynikającego z tego, że chujki nie zaimplementowały możliwości zaznaczania pojedynczej komórki tabeli prawym przyciskiem myszki (zaznacza się cały wiersz).
    * 
    */

    return (
        <div data-cellindex={cellIndex} className="text-center" style={{padding: '.5rem', margin: '0'}}>
            {cellContent}
        </div>
    )
}


/**
 * OKIENKA DIALOGOWE  
 */

function DialogBulkShift({visible, onOk, onHide}) {
    const [value, setValue] = useState(0);

    const dialogFooterContent = (
        <div>
            <Button label="Anuluj" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            <Button label="OK" icon="pi pi-check" onClick={() => {onOk(value)}} autoFocus />
        </div>
    );

    return (
        <Dialog
            header="Przesuń postoje o:" 
            footer={dialogFooterContent} 
            visible={visible}
            onHide={onHide}
        >
            <div className="flex-auto">
                <InputNumber 
                    showButtons 
                    buttonLayout="horizontal"
                    incrementButtonIcon="fa-solid fa-plus" 
                    decrementButtonIcon="fa-solid fa-minus"
                    value={value}
                    onValueChange={(e)=>setValue(e.value)}
                    inputStyle={{width: '100px'}}
                    suffix=" minut"
                /> 
            </div>
        </Dialog>
    )
}

function DialogMoveToStop({visible, onOk, onHide, initialVal}) {
    const [value, setValue] = useState(initialVal);
    const {data : stopsList, isPending} = useQueryGtfsResource('stops');


    const dialogFooterContent = (
        <div>
            <Button label="Anuluj" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            <Button label="OK" icon="pi pi-check" onClick={() => {onOk(value)}} autoFocus />
        </div>
    );

    return (
        <Dialog
            header='Przesuń postój na przystanek:'
            footer={dialogFooterContent} 
            visible={visible}
            onHide={onHide}
            style={{
                maxWidth: '470px'
            }}
        >
            {
                (isPending || !stopsList) ? <ProgressSpinner/> :
                <StopIdPropertyDropdown 
                    propertyName=''
                    initialVal={initialVal}
                    onDone={(property,value) => setValue(value)}
                    options={Object.values(stopsList)}
                />
            }

        </Dialog>
    )

}

function DialogAddStop({visible, onOk, onHide, initialVal}) {
    const [value, setValue] = useState(initialVal);
    const {data : stopsList, isPending} = useQueryGtfsResource('stops');


    const dialogFooterContent = (
        <div>
            <Button label="Anuluj" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            <Button label="OK" icon="pi pi-check" onClick={() => {onOk(value)}} autoFocus />
        </div>
    );

    return (
        <Dialog
            header='Dodaj przystanek:'
            footer={dialogFooterContent} 
            visible={visible}
            onHide={onHide}
            style={{
                maxWidth: '470px'
            }}
        >
            {
                (isPending || !stopsList) ? <ProgressSpinner/> :
                <StopIdPropertyDropdown 
                    propertyName=''
                    initialVal={initialVal}
                    onDone={(property,value) => setValue(value)}
                    options={Object.values(stopsList)}
                />
            }

        </Dialog>
    )

}

function DialogStopTime({visible, onOk, onHide, initialVal}) {
    const [value, setValue] = useState(initialVal);
    const [shiftValue, setShiftValue ] = useState(null);

    if(!value) setValue({
            arrivalTime: "00:00:00",
            departureTime: "00:00:00"
        })

    const dialogFooterContent = (
        <div>
            <Button label="Anuluj" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
            <Button label="OK" icon="pi pi-check" onClick={() => {onOk(value,shiftValue * 60)}} autoFocus />
        </div>
    );

    const handleChangeRestTime = (inputVal) => {
        const arrivalDate = parseTimeStringToDate(value.arrivalTime);
        arrivalDate.setDate(arrivalDate.getDate() + calcAddedDay(value.arrivalTime));

        let departureDate = new Date(arrivalDate.getTime() + (inputVal * 60 * 1000));
        setValue({
            ...value,
            departureTime: formatDateToTimeString(departureDate,calcAddedDay(value.arrivalTime) + (departureDate.getDate() - arrivalDate.getDate()))
        })
    }

    const handleChangeAddedDays = (inputVal,isArrivalTime = false) => {
        let gtfsTimeString = (isArrivalTime) ? value.arrivalTime : value.departureTime;
        if (typeof gtfsTimeString !== 'string') return null;

        const [hh, mm, ss = ':00'] = gtfsTimeString.split(':',3);
        normalizedHour = parseInt(hh) % 24;
        newHour = normalizedHour + (inputVal * 24);

        let newGtfsTimeString = newHour.toString().padStart(2,0) + ":" + mm.toString().padStart(2,0) + ":" + ss.toString().padStart(2,0);

        console.log('added days',inputVal,gtfsTimeString,newGtfsTimeString);

        if (isArrivalTime) {
            setValue({
                ...value,
                arrivalTime: newGtfsTimeString
            })
        } else {
            setValue({
                ...value,
                departureTime: newGtfsTimeString
            })
        }
    }

    const calcShiftStoptimes = () => {
            if (!initialVal) {
                setShiftValue(0);
                return
            }

            let originalDepartureDate = parseTimeStringToDate(initialVal.departureTime,calcAddedDay(initialVal.departureTime));
            let newDepartureDate = parseTimeStringToDate(value.departureTime,calcAddedDay(value.departureTime));
            setShiftValue(
                (newDepartureDate - originalDepartureDate) / 1000 / 60
            );
    }

    const calcAddedDay = (gtfsTimeString) => {
        if (typeof gtfsTimeString !== 'string') return null;
        let hour = gtfsTimeString.split(':')[0];
        return Math.floor(hour/24);
    }

    return (
        <Dialog
            header={(initialVal) ? 'Edytuj postój' : 'Dodaj postój'}
            footer={dialogFooterContent} 
            visible={visible}
            onHide={onHide}
            style={{
                maxWidth: '470px'
            }}
        >
            <div class="formgrid grid">
                    <div class="field col-8">
                        <label htmlFor="arrival-time"  className="block">Godzina przyjazdu</label>
                        <Calendar inputId="arrival-time" 
                            value={ (value) ? parseTimeStringToDate(value.arrivalTime)  : '' } 
                            onChange={(e) => setValue({
                                ...value,
                                arrivalTime: formatDateToTimeString(e.value,calcAddedDay(value.arrivalTime))
                            })} 
                            timeOnly 
                            showSeconds 
                        />
                    </div>
                    <div class="field col-4">
                        <label htmlFor="arrival-day"  className="block">Doba</label>
                        <InputNumber 
                            inputStyle={{maxWidth: '5.5rem'}} 
                            inputId="arrival-day" 
                            value={(value) ? calcAddedDay(value.arrivalTime) : null}
                            onValueChange={(e)=>handleChangeAddedDays(e.value,true)}
                            showButtons 
                            min={0} 
                            prefix="+"
                            suffix={(value && calcAddedDay(value.arrivalTime) === 1) ? " dzień" : " dni"}
                        />
                    </div>
                    <div class="field col-12 text-center">
                        <label htmlFor="rest-time" className="block">Czas postoju</label>
                        <InputNumber 
                            showButtons 
                            buttonLayout="horizontal"
                            incrementButtonIcon="fa-solid fa-plus" 
                            decrementButtonIcon="fa-solid fa-minus"
                            value={
                                (value && parseTimeStringToDate(value.departureTime) && parseTimeStringToDate(value.arrivalTime)) ?
                                    (
                                        parseTimeStringToDate(value.departureTime).getTime() +
                                        (24 * 60 * 60 * 1000 * calcAddedDay(value.departureTime)) - 
                                        parseTimeStringToDate(value.arrivalTime).getTime() -
                                        (24 * 60 * 60 * 1000 * calcAddedDay(value.arrivalTime))
                                    ) / (1000 * 60)
                                :
                                    0
                            }
                            onValueChange={(e)=>handleChangeRestTime(e.value)}
                            inputStyle={{width: '100px'}}
                            suffix=" minut"
                            inputId="rest-time"
                            min={0}
                            useGrouping={false}
                        />                     
                    </div>                  
                    <div class="field col-8">
                        <label htmlFor="departure-time"  className="block">Godzina odjazdu</label>
                        <Calendar inputId="departure-time" 
                            value={ (value) ? parseTimeStringToDate(value.departureTime)  : '' } 
                            onChange={(e) => {
                                setValue({
                                    ...value,
                                    departureTime: formatDateToTimeString(e.value,calcAddedDay(value.departureTime))
                                })
                            }} 
                            timeOnly 
                            showSeconds 
                        />                       
                    </div>
                    <div class="field col-4">
                    <label htmlFor="departure-day"  className="block">Doba</label>
                        <InputNumber 
                            inputStyle={{maxWidth: '5.5rem'}} 
                            inputId="departure-day" 
                            value={(value) ? calcAddedDay(value.departureTime) : null} 
                            onValueChange={(e)=>handleChangeAddedDays(e.value)}
                            showButtons 
                            min={0} 
                            prefix="+"
                            suffix={(value && calcAddedDay(value.departureTime) === 1) ? " dzień" : " dni"}
                        />
                    </div>
            </div>
            <div class="flex align-items-center mt-3">
                <Checkbox 
                    checked={(shiftValue !== null)}
                    onChange={(e) => {
                        if(e.checked === false) setShiftValue(null); else calcShiftStoptimes();
                    }}
                    inputId="enableShift"
                />
                <label className="ml-2" htmlFor="enableShift">Przesuń kolejne postoje na tym kursie</label>
            </div>
            {
                (shiftValue !== null) ? 
                <div class="formgroup-inline mt-3">
                    <div class="field">
                            <label htmlFor="shift" className="mr-4 mb-2">Przesuń o:</label>
                            <InputNumber 
                                showButtons 
                                buttonLayout="horizontal"
                                incrementButtonIcon="fa-solid fa-plus" 
                                decrementButtonIcon="fa-solid fa-minus"
                                value={shiftValue}
                                onValueChange={(e) => setShiftValue(e.value)}
                                inputStyle={{width: '100px'}}
                                suffix=" minut"
                                inputId="shift"
                            />  
                    </div>
                </div> : <></>
            }


        </Dialog>
    )

}


/** 
 *  FUNKCJE POMOCNICZE
 * */ 

function copyTimetable(cells,copyArrivals = false) {
    console.log(cells);
    
    // Inicjalizacja zmiennej do przechowywania tekstu, który będzie skopiowany
    let textToCopy = '';

    // Zmienna do przechowywania numeru poprzedniego wiersza
    let previousCellRow = null;

    // Iterujemy po tablicy obiektów z zawartością komórek
    cells.forEach((element,ind) => {

        // trip_id przechowywane jest w obiekcie kopiowanej komórki jako wartość pola "field", poprzedzona nazwą obiektu, w którym trzymane są odjazdy - trip_deps.
        // (bo to odjazdy stanowią główną wartość pola komórki). Usuwany "trip_deps" z fielda i mamy numer kursu.
        let tripId = String(element.field).replace('trip_deps.','');

        // Czy jesteśmy w nowym wierszu?
        if (previousCellRow !== null && previousCellRow !== element.rowIndex) {
            textToCopy += '\n'; // dodajemy znak nowej linii
        } else if (previousCellRow !== null) {  // ale jeśli pozostajemy w tej samej linii
            textToCopy += '\t'; // dodajemy znak tabulacji (jeżeli to nie jest pierwsza komórka, którą kopiujemy)
        }

        // Z którego zbioru kopiujemy godziny? Odjazdów czy przyjazdów?
        let timeSet = (copyArrivals) ? 'trip_arvs' : 'trip_deps';

        // Jeśli komóka NIE jest pusta
        if(typeof element.rowData[timeSet][tripId] !== 'undefined') {
            let cellText = element.rowData[timeSet][tripId];
            if (String(cellText).length === 8 && String(cellText).endsWith(':00')) cellText = String(cellText).substring(0,5);
            textToCopy += cellText;
        } else {    
            textToCopy += '';  // w przeciwnym razie nic nie kopiujemy
        }

        // Ustawienie bieżącego wiersza jako poprzedniego wiersza
        previousCellRow = element.rowIndex;
    })

    // Kopiowanie do schowka za pomocą API Clipboard
    navigator.clipboard.writeText(textToCopy).then(function() {
            //
    }, function(err) {
            alert('Nie udało się skopiować zawartości: ', err);
    });
}

function getSelectedCellStopTimeKids(cells) {
    let selectedStopTimeKids = [];
    cells.forEach((element) => {
        let tripId = String(element.field).replace('trip_deps.','');

        // Jeśli komóka NIE jest pusta
        if(element.rowData.trip_stoptime_kids[tripId]) {
            selectedStopTimeKids.push(element.rowData.trip_stoptime_kids[tripId]);
        } 
    });
    return selectedStopTimeKids;
}

function getSelectedCellStopTimeData(cells) {
    let selectedStopTimeData = [];
    if (!cells) return null;
    cells.forEach((element) => {
        let tripId = String(element.field).replace('trip_deps.','');

        // Jeśli komóka NIE jest pusta
        if(element.rowData.trip_stoptime_kids[tripId]) {
            selectedStopTimeData.push({
                kid: element.rowData.trip_stoptime_kids[tripId],
                arrivalTime: element.rowData.trip_arvs[tripId],
                departureTime: element.rowData.trip_deps[tripId],
            });
        } 
    });
    return selectedStopTimeData;
}

function getPreviousStopTimeKid(tableContent,tripId,currentRowIndex) {
    for(let i = currentRowIndex; i >= 0; i--) {
        if (typeof tableContent[i].trip_deps !== "undefined" && Object.hasOwn(tableContent[i].trip_deps,tripId)) {
            console.log('found previous stop time at rowindex',i);
            return tableContent[i].trip_stoptime_kids[tripId]
        }
    }
    console.log('no previous stoptimes');
    return null;
}